import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import jwtDecode from "jwt-decode";


    //Updated EZ
  const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();

    let roles;
    let confirmRoles;

    const token = localStorage.getItem("token");
    const role = localStorage.getItem("roles"); 
    
    if (token !== null) {
      //confirmRoles2 = jwtDecode(token).Roles
      confirmRoles = role
      //(role,"role");
    }
    if (auth?.roles === undefined) {
      roles = confirmRoles;
    } else {
      roles = auth?.roles;
    }
  
    const location = useLocation();
  
    const isAuthenticated = (auth && auth.accessToken) || (token !== null);
    
    // If roles is a string (like "admin"), convert it to array for consistency
    const userRoles = Array.isArray(roles) ? roles : [roles];
  
    const hasAllowedRole = allowedRoles?.some((r) => userRoles.includes(r));
    // const hasAllowedRole = roles === allowedRole ? true : false;
    
    if (isAuthenticated) {
      if (hasAllowedRole) {
        return <Outlet />;
      } else {
        return (
          <Navigate
            to="/unauthorized"
            state={{ from: location }}
            replace
          />
        );
      }
    } else {
      return (
        <Navigate
          to="/auth/sign-in"
          state={{ from: location }}
          replace
        />
      );
    }
  };
export default RequireAuth;